import React, { useState, useEffect, useMemo } from 'react';
import { fmtPrice } from '../../../utils/format';

/*
props:
- symbol
- data
*/
function BookRow(props) {

    const [data, setData] = useState({
        bid: '0',
        ask: '0',
    });

    // The spot feed is miniTicker — bestBid equals bestAsk by construction, so two
    // identical columns were a lie. One "market price" cell tells the truth.
    const bookRow = useMemo(() => (
        <tr>
        <td className="text-gray-900">{props.symbol}</td>
        <td className="text-gray-900 num">{fmtPrice(data.bid)}</td>
    </tr>), [data.bid, data.ask])

    useEffect(() => {
        if (!props.data) return;
        if (data.bid !== props.data.bestBid || data.ask !== props.data.bestAsk)
            setData({ bid: props.data.bestBid, ask: props.data.bestAsk });
    }, [props.data]);

    return (bookRow)
}

export default BookRow;